import { Constants } from "../constants";
import { ErrorsActionTypes, IError } from "../types";

const initialState: IError = {
    message: "",
    status: null,
};

const errorReducers = (
    state = initialState,
    action: ErrorsActionTypes,
): IError => {
    switch (action.type) {
        case Constants.ERROR:
            return { message: action.payload.message, status: action.payload.status };
        default:
            return state;
    }
};

export default errorReducers;